import { LOCALE_TYPE } from 'locales/locale';
import { LocaleType } from 'types/constants/locale';
import { MainMenuItemEditModel, MainMenuItemModel } from 'types/entity';

export const mainMenuEditToMainMenu = (
  entity: MainMenuItemEditModel,
  locale: LocaleType,
): MainMenuItemModel => ({
  main_menu_item_id: entity.main_menu_item_id,
  main_menu_item_type_code: entity.main_menu_item_type_code,
  main_menu_id: entity.main_menu_id,
  display_order: entity.display_order,
  content_tag_id: entity.content_tag_id,
  common_management_flag: entity.common_management_flag,
  dc_management_code: entity.dc_management_code,
  view_code: entity.view_code,
  data_rack_id: entity.data_rack_id,
  search_criteria_id: entity.search_criteria_id,
  url: entity.url,
  display_name: locale === LOCALE_TYPE.EN ? entity.display_name_en || '' : entity.display_name_ja || '',
  file_service_left_pain_control_type: entity.file_service_left_pain_control_type,
});
